import { render } from "./TokenizeJourney.vue?vue&type=template&id=70d95480&scoped=true"
import script from "./TokenizeJourney.vue?vue&type=script&lang=js"
export * from "./TokenizeJourney.vue?vue&type=script&lang=js"

import "./TokenizeJourney.vue?vue&type=style&index=0&id=70d95480&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d95480"]])

export default __exports__